// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../variables.css\"","mobile-threshold-width":"610px","listTitle":"ListTitle_listTitle__xyMQH"};